<div class="withdrawal-draft-card">
    <div class="header">
        {{ 'money.withdrawalDraft.header.' + investmentType | translate }}
        &#34;<div class="name">{{ withdrawalDraft.portfolioName }}</div>&#34;
    </div>

    <div class="draft-background">
        <div class="row">
            <div class="col-6 gx-3 first-row">
                <div class="label">
                    {{ 'money.withdrawalCard.value' | translate }}
                </div>
                <div
                    class="value value--amount"
                    [ngClass]="{
                        'value--small-font': withdrawalDraft.value > longTextBreakpoints.valueSmall,
                        'value--smallest-font': withdrawalDraft.value > longTextBreakpoints.valueSmallest,
                    }"
                >
                    {{ withdrawalDraft.value | price:'CZK' }}
                </div>
            </div>
            <div class="col-6 gx-3 d-flex flex-column justify-content-end first-row">
                <div class="label">
                    {{ 'money.withdrawalCard.frequency' | translate }}
                </div>
                <div class="value">
                    {{ (withdrawalDraft.frequency === regularWithdrawalFrequencies.MONTHLY ? 'money.withdrawalForm.frequencyMonthly' : 'money.withdrawalForm.frequencyQuaterly') | translate }}
                </div>
            </div>

            <div class="col-6 gx-3">
                <div class="label">
                    {{ 'money.withdrawalCard.validTo' | translate }}
                </div>
                <div class="value">
                    {{ withdrawalDraft.validTo  ? (withdrawalDraft.validTo | date:'d. M. y') : '-' }}
                </div>
            </div>
            <div class="col-6 gx-3">
                <div class="label">
                    {{ 'money.withdrawalCard.bankAccount' | translate }}
                </div>
                <div
                    class="value"
                    [ngClass]="{ 'value--small-font': withdrawalDraft.accountNumber.length > longTextBreakpoints.accountNumber }"
                >
                    {{ withdrawalDraft.accountNumber }}
                </div>
            </div>

            <div class="col-12 p-0">
                <div class="buttons-container">
                    @if(!aml) {
                        <libero-button
                          label="{{ 'global.buttons.updateAml' | translate }}"
                          [uppercase]="false"
                          btnClasses="btn--secondary btn--draft-card btn--danger-border btn--aml"
                          (click)="goToAMLForm()"
                          data-cy="withdrawal-draft-update-aml-btn"
                        ></libero-button>
                    } @else {
                        <libero-button
                            label="{{ 'global.accept' | translate }}"
                            btnClasses="btn--primary btn--draft-card"
                            data-cy="draft-accept-btn"
                            [disabledTooltipText]="isExpired ? 'regularDraftExpired' : (waitingForMailConfirm ? 'dipRegularDraftConfirm' : null)"
                            (click)="acceptDraft()"
                            [preloader]="preloader.accept"
                            [buttonDisabled]="preloader.refuse || waitingForMailConfirm || isExpired"
                        ></libero-button>
                    }
                    <libero-button
                        label="{{ 'global.refuse' | translate }}"
                        btnClasses="btn--danger btn--draft-card"
                        data-cy="draft-refuse-btn"
                        (click)="refuseDraft()"
                        [preloader]="preloader.refuse"
                        [buttonDisabled]="preloader.accept"
                    ></libero-button>
                </div>
            </div>
            <div class="col-12 text-center mt-3">
                <div class="comment-btn-wrapper">
                    <libero-button
                        label="{{ 'money.withdrawalCard.consultComment' | translate }}"
                        btnClasses="btn--secondary btn--card-action"
                        [preloaderInverse]="false"
                        [smallSecondary]="true"
                        (click)="displayComment()"
                    ></libero-button>
                </div>
            </div>
        </div>
    </div>
    <div class="withdrawal-draft-footer">
        @if(expireInDays) {
            <svg-icon src="assets/icons/clock.svg" [svgStyle]="{ 'width.px':22, 'height.px':22, 'transform': 'translateY(-2px)' }"></svg-icon>
            <p>
                {{ 'money.withdrawalCard.draftExpires' | translate }}
                <span class="text-success">
                    {{ expireInDays }}
                    {{ 'money.withdrawalCard.days' | translate }}
                </span>
            </p>
        }
    </div>
</div>
